/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button, Dropdown } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommonModal from './CommonModal';
import { AddDrugFamily, DuplicateDrugFamily } from './CreateContractModal';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomLoadingCellRenderer from '../../../../SharedModules/Table/CustomComponentsForTable/loadingSpinnerRenderer';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import TextBoxRender from './gridComponents/TextBoxRender';
import SelectBoxRender from './gridComponents/SelectBoxRender';
import drugFamilyHead from './gridComponents/drugFamilyHeader';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { createFlag } from '../../DrugFamily/DrugFamilyDetails/store/actions';
import { getDrugFamilyDetails } from '../../DrugFamily/DrugFamilySearch/store/actions';
import * as actionType from '../../DrugFamily/DrugFamilySearch/store/actionTypes';
import {
  redirectURLLink,
  checkQuarterValidation,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  maintainContractActions,
  errorMaintainContractActions,
  dispatchDrugTable,
  handleErrorMessages,
  getExistingCorrLinkIds,
  dispatchDeleteDrugFamily,
  selectedRow,
} from '../store/actions';
import {
  getRebatePriceLevelDetailsApi,
  storePriceLevelSearchData,
} from '../../RebatePriceLevel/store/actions';

import {
  getMaintanancePriceHeaderDetails,
  getPlanTypeDescription,
  dispatchMaintanancePriceDetails,
  storePriceSearchInputData,
} from '../../RebatePriceDetails/store/actions';
import { SUCCESS_MSG } from '../../../../SharedModules/Errors/constantMessageData';
import { getCalculatedData } from '../../../Display/URASearch/store/actions';
import {
  autoFormateDate,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';

const DrugFamilyTabComponent = (props) => {
  const { fullScreenView, setFullScreenView } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const drugFamily = useSelector(
    (state) =>
      state?.sharedState?.ContractReducer?.maintainContractState?.drugFamily
  );
  const getDrugFamilyTable = useSelector(
    (state) => state.sharedState.ContractReducer.getDrugFamilyTable
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const drug_family_details = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.drug_family_details
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const getAllContractData = useSelector(
    (state) => state.sharedState?.ContractReducer?.getAllContractData
  );
  const searchPageValues = useSelector(
    (state) => state.sharedState.PriceLevel.priceLevelSearchdata
  );
  const getInputValues = useSelector(
    (state) => state.sharedState.PriceDetails.priceLevelSearchInputdata
  );
  const calculatedURAHeaderDataList = useSelector(
    (state) => state.sharedState.URASearchReducer.calculatedURAHeaderDataList
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const gridRef = React.useRef();
  const [gridParams, setGridParams] = React.useState(null);
  const [openCreatePopup, setOpenCreatePopup] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [showComments, setShowComments] = React.useState(false);
  const [rowGridPrimaryKey, setRowGridPrimaryKey] = React.useState('');
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(
      process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
      kcRoles
    )
  );
  const [stateCC, setStateCC] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [cellInfo, setCellInfo] = React.useState('');
  const [duplicatePopUp, setDuplicatePopUp] = React.useState(false);
  const [deletePopup, setDeletePopup] = React.useState(false);

  const onGridReady = (params) => {
    setGridParams(params);
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_ROLES_FOR_DISABLED_FIELDS,
          kcRoles
        )
      );
    }
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const onSelectionChanged = useCallback(
    (val) => {
      const selectedRows = val.api.getSelectedRows();
    },
    [gridApi]
  );
  React.useEffect(() => {
    if (drug_family_details) {
      const { status, message } = drug_family_details;
      if (message === 'SUCESS' && status === '001') {
        dispatch({
          type: actionType.DRUG_FAMILY_DAETAILS,
          payload: null,
        });
        if (drug_family_details?.drugFamilyVOs?.length > 1) {
          dispatch({
            type: actionType.POPUP_TABLE_DATA,
            payload: drug_family_details.drugFamilyVOs,
          });
        } else {
          dispatch(createFlag(false));

          localStorage.setItem('updatedetails', true);
          redirectURLLink(
            '/drugFamilyDetail',
            'View Drug Family Details',
            history,
            dispatch
          );
        }
      }
    }
  }, [drug_family_details]);

  const onCloseCreateContract = () => {
    setOpenCreatePopup(false);
    setDuplicatePopUp(false);
  };
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments && getDrugFamilyTable && getDrugFamilyTable.length > 0) {
      setStateCC(false);
      const tempObj = getDrugFamilyTable.map((item) => {
        if (
          item.corrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          setStateCC(false);
          item.cc_COMMENTS_EXIST = 1;
        } else if (item.corrLinkId === corrLinkId) {
          item.cc_COMMENTS_EXIST = 0;
        }
        return item;
      });
      setStateCC(true);
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.refreshCells();
    }
  }, [commentsList]);

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data) => {
    setStateCC(true);
    if (
      getDrugFamilyTable &&
      getDrugFamilyTable?.length > 0 &&
      getDrugFamilyTable?.filter((x) => {
        return x.corrLinkId !== null;
      }).length > 0
    ) {
      setStateCC(false);
      const result = await getExistingCorrLinkIds({
        corrLinkId: getDrugFamilyTable
          .filter((x) => {
            return x.corrLinkId !== null;
          })
          .map((item) => {
            return item.corrLinkId;
          }),
      });
      const tempObj =
        getDrugFamilyTable &&
        getDrugFamilyTable.map((item) => {
          if (
            result &&
            result.data?.length > 0 &&
            result.data?.filter((x) => {
              return x === item.corrLinkId;
            }).length > 0
          ) {
            item.cc_COMMENTS_EXIST = 1;
          } else {
            item.cc_COMMENTS_EXIST = 0;
          }
          item.sharegroup = item.sharegroup || false;
          return item;
        });
      setStateCC(true);
      // eslint-disable-next-line no-unused-expressions
      gridParams?.api?.refreshCells();
    }
  };

  React.useEffect(() => {
    handleExistingCommentList(getDrugFamilyTable);
  }, [getDrugFamilyTable]);
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };

  const loadingCellRenderer = useMemo(() => {
    return CustomLoadingCellRenderer;
  }, []);
  const onChangeDetailsField = (e, name) => {
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
    const data = {
      ...maintainContractState,
      showSaveButton: 'Yes',
      drugFamily: {
        ...drugFamily,
        [name]: e.target.value,
      },
    };
    dispatch(maintainContractActions(data));
  };
  // check validation for filed Level
  const handleOnBlurEventOnFields = (value, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (value !== '') {
      if (checkQuarterValidation(value)) {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        dispatch(
          maintainContractActions({
            ...maintainContractState,
            drugFamily: {
              ...drugFamily,
              [name]: autoFormateDate(value?.toUpperCase()),
            },
          })
        );
      } else {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'invalidQuarterFormat',
          tabName: 'DrugFamily',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr?.filter((item) => item.fieldName !== name);
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  const assignStartDate = () => {
    const localErr = errorMessagesFromRedux || [];
    if (drugFamily.drugFamilyQtr === '' && !drugFamily.errorInvalidQuarter) {
      // const errorShown = [...errorMaintainContract];
      // const error = [
      //   ...new Set([...errorShown, constantMessageData.DEFAULT_START_QTR]),
      // ];
      // dispatch(errorMaintainContractActions(error));
      localErr.push({
        fieldName: 'drugFamilyQtr',
        errorType: 'startQuarterRequired',
        tabName: 'DrugFamily',
        message: constantMessageData.DEFAULT_START_QTR,
      });
      dispatch(handleErrorMessages([...new Set(localErr)]));
    } else if (
      drugFamily.drugFamilyQtr !== '' &&
      !drugFamily.errorInvalidQuarter
    ) {
      const tableData = [...getDrugFamilyTable];
      const arr =
        tableData &&
        tableData.map((item) => {
          if (item.startquarter == '' || item.startquarter == undefined) {
            item.startquarter = drugFamily.drugFamilyQtr;
          }
          return item;
        });
      dispatch(dispatchDrugTable(arr, '', '', 'onLoad'));
      gridParams && gridParams.api && gridParams.api.refreshCells();
    }
  };
  const onClickCreateContractDailog = (data) => {
    handleClearFilter();
    const dgFamily = {};
    dgFamily.drugfamilyname = data.familyName;
    dgFamily.startquarter = '';
    dgFamily.endquarter = '';
    dgFamily.REBATE_PRICING_METHOD_CD = '-1';
    dgFamily.VOLUME_CALC_METHOD_CD = '-1';
    dgFamily.MKT_SHARE_CALC_METHOD_CD = '-1';
    dgFamily.basketname = '-1';
    dgFamily.NAT_MKT_SHARE_TYPE_CD = '-1';
    dgFamily.sharegroup = '';
    dgFamily.subgroupid = '';
    dgFamily.comments = '';
    dgFamily.corrLinkId = null;
    dgFamily.action = '';
    dgFamily.endQtrErr = false;
    dgFamily.startQtrErr = false;
    dgFamily.contractFamilySeqNum = null;
    dgFamily.familySeqNum = data.familySeqNum;
    dgFamily.alreadyAdded = false;
    dgFamily.rebateProgramCd = maintainContractState?.rebateProgramCd;
    dgFamily.mfgId = maintainContractState?.mfgId;
    dispatch(dispatchDrugTable(dgFamily, cellInfo.rowIndex, '', 'Add'));
    setOpenCreatePopup(false);
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  // click on Duplicate option
  const onClickOkDuplicateButton = (data) => {
    handleClearFilter();
    const dgFamily = {};
    dgFamily.drugfamilyname = cellInfo.data.drugfamilyname;
    dgFamily.startquarter = data;
    dgFamily.endquarter = '';
    dgFamily.REBATE_PRICING_METHOD_CD = '-1';
    dgFamily.VOLUME_CALC_METHOD_CD = '-1';
    dgFamily.MKT_SHARE_CALC_METHOD_CD = '-1';
    dgFamily.basketname = '-1';
    dgFamily.NAT_MKT_SHARE_TYPE_CD = '-1';
    dgFamily.sharegroup = '';
    dgFamily.subgroupid = '';
    dgFamily.comments = '';
    dgFamily.action = '';
    dgFamily.endQtrErr = false;
    dgFamily.startQtrErr = false;
    dgFamily.contractFamilySeqNum = null;
    dgFamily.familySeqNum = cellInfo.data.familySeqNum;
    dgFamily.alreadyAdded = false;
    dgFamily.rebateProgramCd = maintainContractState?.rebateProgramCd;
    dgFamily.mfgId = maintainContractState?.mfgId;
    dispatch(dispatchDrugTable(dgFamily, cellInfo.rowIndex, '', 'Add'));
    setDuplicatePopUp(false);
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
    let localErr = errorMessagesFromRedux || [];
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  // click on delete option
  const deleteSelectRowData = () => {
    let localErr = errorMessagesFromRedux || [];
    dispatch(dispatchDrugTable({}, cellInfo.rowIndex, '', 'Delete'));
    if (cellInfo.data.alreadyAdded == true) {
      dispatch(dispatchDeleteDrugFamily(cellInfo.data));
    }

    setCellInfo('');
    setDeletePopup(false);
    localErr = localErr?.filter(
      (item) =>
        !item.message?.includes(`3Q1997' for Row ${cellInfo.rowIndex + 1}`)
    );
    localErr = localErr?.filter(
      (item) =>
        !item.message?.includes(
          `${constantMessageData.END_QTR_GRATER_START_QTR_ERR} ${
            cellInfo.rowIndex + 1
          }`
        )
    );
    localErr = localErr?.filter(
      (item) => item.message !== constantMessageData.CONTRACT_NO_CALCULATED_URA
    );
    dispatch(handleErrorMessages([...new Set(localErr)]));
    dispatch(
      maintainContractActions({
        ...maintainContractState,
        showSaveButton: 'Yes',
      })
    );
  };

  // move to drug family tab
  const moveToDrugFamily = (selectedRows) => {
    dispatch(
      getDrugFamilyDetails({
        familySeqNum: selectedRows.familySeqNum,
      })
    );
  };
  const moveToRebatePriceLevel = async (selectedRows) => {
    const detailsObj = {
      rebateProgramCd: selectedRows.rebateProgramCd,
      qtr: selectedRows.startquarter,
      mfgId: selectedRows.mfgId,
      drugfamilyId: selectedRows.familySeqNum,
    };
    dispatch(
      storePriceLevelSearchData({
        ...searchPageValues,
        rebateProgramCd: selectedRows.rebateProgramCd,
      })
    );
    const temp = await dispatch(getRebatePriceLevelDetailsApi(detailsObj));
    const { message, rebateProgramLevel } = temp.payload;
    if (message === SUCCESS_MSG) {
      if (
        rebateProgramLevel.length > 0 &&
        rebateProgramLevel[0]?.getDetailsHeader?.length > 0
      ) {
        redirectURLLink(
          '/priceDetails',
          'Maintain Rebate Price Details',
          history,
          dispatch
        );
      } else {
        let localErr = errorMessagesFromRedux || [];
        localErr.push({
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
          type: 'NoNotFound',
          tabName: 'DrugFamily',
        });
        handleScrollToEvent();
        dispatch(handleErrorMessages([...new Set(localErr)]));
        await Promise.resolve();
        // setTimeout(() => {
          localErr = localErr?.filter((item) => item.type !== 'NoNotFound');
          dispatch(handleErrorMessages([...new Set(localErr)]));
        // }, 5000);
      }
    }
  };
  const moveToRebatePriceDetails = async (selectedRows) => {
    const results = await getMaintanancePriceHeaderDetails({
      rpc: selectedRows.rebateProgramCd,
      familyId: selectedRows.familySeqNum,
      mfg: selectedRows.mfgId,
      qtr: selectedRows.startquarter,
    });
    dispatch(
      getPlanTypeDescription({
        codeDomainList: ['PLAN_TYPE_CD'],
      })
    );
    if (results?.status === '001') {
      dispatch(dispatchMaintanancePriceDetails(results));
      dispatch(
        storePriceSearchInputData({
          ...getInputValues,
          mfgId: selectedRows.mfgId,
          familySeq: selectedRows.familySeqNum,
        })
      );
      if (
        results?.rebatePriceDetailsHeaderResponseVO
          ?.maintainRebateProgramHeaderVO?.length > 0
      ) {
        redirectURLLink(
          '/rebatePriceDetails',
          'Rebate Price Details',
          history,
          dispatch
        );
      } else {
        let localErr = errorMessagesFromRedux || [];
        localErr.push({
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
          type: 'NoNotFound',
          tabName: 'DrugFamily',
        });
        handleScrollToEvent();
        dispatch(handleErrorMessages([...new Set(localErr)]));
        await Promise.resolve();
        // setTimeout(() => {
          localErr = localErr?.filter((item) => item.type !== 'NoNotFound');
          dispatch(handleErrorMessages([...new Set(localErr)]));
        // }, 5000);
      }
    }
  };

  // Compare Drug Details Modal popup open
  const selectedTab = (cellInfo) => {
    dispatch(selectedRow(cellInfo?.data?.drugfamilyname));
  };
  const moveToCalculatedURA = async (selectedRows, errorMessagesInRedux) => {
    const requestData = {
      drugFamilyseqNum: [String(selectedRows.familySeqNum)],
      ndcList: ['-1'],
      mfgIdList: ['-1'],
      rebateProgramCd: selectedRows.rebateProgramCd,
      selectOneOption: 'drugfamily',
      planType: 'C',
      startQtr: selectedRows.startquarter,
      qtrType: 'TARGET',
    };
    const response = await dispatch(getCalculatedData(requestData));
    if (response?.length > 0) {
      let localErr = errorMessagesInRedux || [];
      localErr = localErr?.filter((item) => item.fieldName !== 'NoCalURA');
      dispatch(handleErrorMessages([...new Set(localErr)]));
      redirectURLLink(
        '/selected-ura',
        'Selected Calculated URA',
        history,
        dispatch
      );
    } else if (response?.length == 0) {
      const localErr = errorMessagesInRedux;
      localErr.push({
        fieldName: 'NoCalURA',
        errorType: 'NoCalURAMessage',
        tabName: 'DrugFamily',
        message: constantMessageData.CONTRACT_NO_CALCULATED_URA,
      });
      dispatch(handleErrorMessages([...new Set(localErr)]));
    }
  };

  const frameworkComponents = useMemo(() => {
    return {
      ActionCellRender: (cellInfo) => {
        const errorMessagesFromRedux = useSelector((state) => {
          return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
        });
        return (
          <div className='tdCell icon-btn-group' data-testid='action-column'>
            {hasAccess && (
              <>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='add-tooltip'>Add</Tooltip>}
                >
                  <Button
                    className='float-left'
                    data-testid='add-new-log-check'
                    aria-label='Add new log check'
                    variant='text'
                    disabled={isEnablebyRole === false}
                    onClick={() => {
                      setOpenCreatePopup(true);
                      setCellInfo(cellInfo);
                    }}
                  >
                    <SVGComponent iconName='Icon-addCircle' />{' '}
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='add-tooltip'>Delete</Tooltip>}
                >
                  <Button
                    className='float-left'
                    data-testid='add-new-log-check'
                    aria-label='Delete'
                    disabled={isEnablebyRole === false}
                    variant='text'
                    onClick={() => {
                      setCellInfo(cellInfo);
                      setDeletePopup(true);
                    }}
                  >
                    <SVGComponent iconName='Icon-delete' />{' '}
                  </Button>
                </OverlayTrigger>
              </>
            )}
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
            >
              {cellInfo?.data?.corrLinkId !== null &&
              cellInfo?.data?.corrLinkId !== '' ? (
                <Button
                  className={`th-ic comment-ic ${
                    parseInt(cellInfo.data.cc_COMMENTS_EXIST, [0, 1]) === 1
                      ? 'frr-enabled-comment-btn'
                      : 'frr-disabled-comment-btn'
                  }`}
                  variant='text'
                  onClick={() => {
                    setCorrLinkId(cellInfo.data && cellInfo.data.corrLinkId);
                    setRowGridPrimaryKey(
                      cellInfo.data && cellInfo.data.drugSeqNum
                    );
                    setShowComments(true);
                    setStateCC(false);
                  }}
                  tabIndex={'0'}
                  onKeyDown={(e) => {
                    // Handle Enter and Space key events
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); // Prevents the default space scrolling behavior
                      setCorrLinkId(cellInfo.data && cellInfo.data.corrLinkId);
                      setRowGridPrimaryKey(
                        cellInfo.data && cellInfo.data.drugSeqNum
                      );
                      setShowComments(true);
                      setStateCC(false);
                    }
                  }}
                >
                  {parseInt(cellInfo.data.cc_COMMENTS_EXIST, [0, 1]) === 1 ? (
                    <img alt='comment' src={CommentVisibleIcon} />
                  ) : (
                    <img alt='comment' src={CommentIcon} />
                  )}
                </Button>
              ) : (
                <Button
                  disabled
                  type='button'
                  aria-label='comment'
                  className='th-ic comment-ic frr-disabled-comment-btn'
                  variant='text'
                >
                  <img alt='comment' src={CommentIcon} />
                </Button>
              )}
            </OverlayTrigger>
            <Dropdown className='icon-dropdown-container'>
              <Dropdown.Toggle
                className='icon-dropdown export_wrap'
                aria-label='export'
              >
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id='action-tooltip'>Actions</Tooltip>}
                >
                  <SVGComponent iconName='Icon-export1' />
                </OverlayTrigger>
              </Dropdown.Toggle>
              <Dropdown.Menu className='export_dropdown'>
                {hasAccess && (
                  <Dropdown.Item
                    role='button'
                    data-testid='Duplicate'
                    // disabled={isEnablebyRole === false}
                    onClick={() => {
                      setDuplicatePopUp(true);
                      setCellInfo(cellInfo);
                      selectedTab(cellInfo);
                    }}
                  >
                    Duplicate
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  role='button'
                  data-testid='calculatedURA'
                  disabled={cellInfo.data.alreadyAdded !== true}
                  onClick={() => {
                    moveToCalculatedURA(cellInfo.data, errorMessagesFromRedux);
                  }}
                >
                  Go To Calculated URA
                </Dropdown.Item>
                <Dropdown.Item
                  role='button'
                  data-testid='goDrugFamily'
                  onClick={() => {
                    moveToDrugFamily(cellInfo.data);
                  }}
                >
                  Go To Drug Family
                </Dropdown.Item>
                <Dropdown.Item
                  role='button'
                  data-testid='marketBasket'
                  disabled
                  // onClick={() => {
                  //   redirectURLLink('/Wip', 'Work In Progress', history);
                  // }}
                >
                  Go To Market Basket
                </Dropdown.Item>
                <Dropdown.Item
                  role='button'
                  data-testid='rebatePricingFormula'
                  disabled
                  // onClick={() => {
                  //   redirectURLLink('/Wip', 'Work In Progress', history);
                  // }}
                >
                  Go To Rebate Pricing Formula
                </Dropdown.Item>
                <Dropdown.Item
                  role='button'
                  data-testid='rebatePricingLevel'
                  disabled={cellInfo.data.alreadyAdded !== true}
                  onClick={() => {
                    moveToRebatePriceLevel(cellInfo.data);
                  }}
                >
                  Go To Rebate Pricing Level
                </Dropdown.Item>
                <Dropdown.Item
                  role='button'
                  data-testid='rebatePricingDetail'
                  disabled={cellInfo.data.alreadyAdded !== true}
                  onClick={() => {
                    moveToRebatePriceDetails(cellInfo.data);
                  }}
                >
                  Go To Rebate Pricing Detail
                </Dropdown.Item>
                <Dropdown.Item
                  role='button'
                  data-testid='marketShare'
                  disabled
                  // onClick={() => {
                  //   redirectURLLink('/Wip', 'Work In Progress', history);
                  // }}
                >
                  Go To Market Share
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
      StartQuarter: (params) => {
        return (
          <TextBoxRender
            hasAccess={hasAccess}
            isEnablebyRole={isEnablebyRole}
            {...params}
          />
        );
      },
      EndQuarter: (params) => {
        return (
          <TextBoxRender
            hasAccess={hasAccess}
            isEnablebyRole={isEnablebyRole}
            {...params}
          />
        );
      },
      SelectBoxRender: (params) => {
        return (
          <SelectBoxRender
            hasAccess={hasAccess}
            isEnablebyRole={isEnablebyRole}
            {...params}
          />
        );
      },
      CheckboxRender: (cellInfo) => {
        return (
          <>
            <div className='tbl-checkbox'>
              <FormControlLabel
                label='test1'
                className='frr-display-hidden-label'
                data-testid='checkbox-filed'
                control={<Checkbox color='primary' />}
                disabled={!hasAccess || !isEnablebyRole}
                onClick={(e) => {
                  cellInfo.node.setDataValue(
                    cellInfo.column.colId,
                    e.target.checked
                  );
                }}
                checked={cellInfo.value}
                value={cellInfo.value}
              />
            </div>
          </>
        );
      },
      ToolTipRender: (cellInfo) => {
        const name = cellInfo?.data?.drugfamilyname;
        if (name && name.length > 22) {
          return (
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
            >
              <div>{name}</div>
            </OverlayTrigger>
          );
        }
        return <div>{name}</div>;
      },
    };
  }, [hasAccess]);
  
  return (
    <div
      className='tBillPanel custom-check'
      data-testid='Drug-family-component'
    >
      <Spinner load={spinnerLoader} />

      <div className=''>
        {!fullScreenView && (
          <div className='form-wrapper'>
            <div className='mui-custom-form input-md'>
              <TextField
                data-testid='default-start-quarter-textField'
                id='Default-start-quarter'
                label='Default Start Quarter '
                className='mandate-fields'
                fullWidth  
                placeholder=''
                inputProps={{ maxLength: 6 }}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={isEnablebyRole === false}
                value={drugFamily?.drugFamilyQtr}
                onChange={(e) => {
                  onChangeDetailsField(e, 'drugFamilyQtr');
                }}
                onBlur={(e) => {
                  handleOnBlurEventOnFields(e.target.value, 'drugFamilyQtr');
                }}
                helperText={
                  errorMessagesFromRedux?.length > 0
                    ? [
                        ...new Set(
                          errorMessagesFromRedux
                            ?.filter((x) => {
                              return x.fieldName === 'drugFamilyQtr';
                            })
                            .map((item) => {
                              return item.message;
                            })
                        ),
                      ]
                    : null
                }
                error={
                  errorMessagesFromRedux?.length > 0 &&
                  errorMessagesFromRedux?.filter((x) => {
                    return x.fieldName === 'drugFamilyQtr';
                  }).length > 0
                    ? [
                        ...new Set(
                          errorMessagesFromRedux
                            ?.filter((x) => {
                              return x.fieldName === 'drugFamilyQtr';
                            })
                            .map((item) => {
                              return item.message;
                            })
                        ),
                      ]
                    : false
                }
              />
            </div>
            <div className='float-right'>
              <OverlayTrigger
                placement='bottom'
                overlay={<Tooltip id='action-tooltip'>Action</Tooltip>}
              >
                <Dropdown className='icon-dropdown-container frr-lab-diff-action-icon-container'>
                  <Dropdown.Toggle
                    className='icon-dropdown'
                    aria-label='Show Contracts using this Contact'
                  >
                    <SVGComponent iconName='Icon-export' />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      role='button'
                      data-testid='copyContractData'
                      onClick={() => {
                        assignStartDate();
                      }}
                    >
                      Assign Start Date
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </OverlayTrigger>
            </div>
          </div>
        )}
        <div
          id='testGrid'
          className='panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk'
        >
          {/* {(stateCC || getDrugFamilyTable?.length === 0)
            ? ( */}
          <TableGrid
            ref={gridRef}
            rowData={getDrugFamilyTable}
            columnDefs={drugFamilyHead}
            gridHeight={fullScreenView ? '70vh' : 400}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            applyFilter={false}
            exportFile
            gridCall={onGridReady}
            // tabToNextCell={tabToNextCell}
            onCellFocused={onCellFocused}
            navigateToNextCell={navigateToNextCell}
            onSelectionChanged={onSelectionChanged}
            fileName='Maintain Contract - Drug Family'
            frameworkComponents={frameworkComponents}
            loadingCellRenderer={loadingCellRenderer}
            addTxt={hasAccess && 'Add Drug Family'}
            disableAddAction={isEnablebyRole === false}
            addAction={() => {
              setOpenCreatePopup(true);
              setCellInfo(cellInfo);
            }}
          />
          {/* ) : null
          } */}
        </div>
      </div>
      <CommonModal
        open={openCreatePopup}
        viewAction
        viewHeader
        modalTitle='Insert New Version of Existing Drug'
        data-testid='create_popup'
        className='panel-header'
        onClose={onCloseCreateContract}
        childrenComponent={
          <AddDrugFamily
            onClickCreateContractDailog={(data) =>
              onClickCreateContractDailog(data)
            }
            data-testid='add_drug'
            onCloseCreateContract={onCloseCreateContract}
          />
        }
      />
      <CommonModal
        open={duplicatePopUp}
        viewAction
        viewHeader
        className='dialogPanel custom-check dialog-500'
        data-testid='duplicate_popup'
        modalTitle='Insert New Version of Existing Drug'
        // className="panel-header"
        onClose={onCloseCreateContract}
        childrenComponent={
          <DuplicateDrugFamily
            onClickOkDuplicateButton={(data) => {
              onClickOkDuplicateButton(data);
            }}
            onCloseCreateContract={onCloseCreateContract}
          />
        }
      />
      <SaveCancelPopup
        open={deletePopup}
        data-testid='deletePopup'
        title='Delete'
        moduleName='the selected record'
        onConfim={() => {
          deleteSelectRowData();
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='CONTRACT'
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};
export default DrugFamilyTabComponent;
